import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from "@angular/router";
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { SlotInfoDto } from '@shared/src/dtos/address/slots/SlotInfoDto';
import { OpenResource } from '@shared/src/dtos/open/OpenResource';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { PhaseSlotChangeReasonDataInfoDto } from '@shared/src/dtos/phase/slot/manage/reason/PhaseSlotChangeReasonDataInfoDto';
import { PhaseSlotChangeReasonActionTypes } from '@shared/src/enums/PhaseSlotChangeReasonActionTypes';
import { AddressTimetableIntervalDto, AlertService, HDate, HHourInterval, HomeController, SharedSlotPickerComponent } from '@shared/src/public-api';

@Component({
    selector: 'shared-exwork-slotpicker-component',
    templateUrl: './shared.exwork.slotpicker.component.html',
    styleUrls: ['./shared.exwork.slotpicker.component.scss']
})
export class SharedExworkSlotPickerComponent implements OnInit {
    constructor(protected activatedRoute: ActivatedRoute, public dialog: MatDialog,
        public openRouteController: OpenRouteController, public systemController: SystemController,
        @Inject('HomeController') public homeController: HomeController,
        @Inject('AlertService') public alertService: AlertService) {
    }

    ngOnInit(): void {
    }

    @Input()
    public driver: boolean = false;

    public __uuid: string;
    @Input()
    public set uuid(value: string) {
        if (this.__uuid == value)
            return;
        this.__uuid = value;
        this.getInfo();
    }
    public get uuid(): string {
        return this.__uuid;
    }

    public __phase: PhaseCardItemDto;
    @Input()
    public set phase(value: PhaseCardItemDto) {
        if (this.__phase == value)
            return;
        this.__phase = value;
        this.getInfo();
    }
    public get phase(): PhaseCardItemDto {
        return this.__phase;
    }

    @Input()
    public slotInfo: SlotInfoDto;

    public __autoOpen: boolean;
    @Input()
    public set autoOpen(value: boolean) {
        if (this.__autoOpen == value)
            return;
        this.__autoOpen = value;
        this.getInfo();
    }
    public get autoOpen(): boolean {
        return this.__autoOpen;
    }

    @Input()
    public readonly: boolean = false;

    public realDate: HDate;
    public nooptions: boolean = false;
    public showObservacions: boolean = false;
    public canSlotRelease: Boolean = false;
    public realInterval: HHourInterval;
    public loading = false;
    getInfo() {
        if (this.autoOpen)
            this.getSlots(false);
    }

    public show = false;
    getSlots(busy: boolean) {
        this.show = true;
        this.loading = true;
        this.nooptions = false;
        this.canSlotRelease = false;
        if (this.uuid && this.phase) {
            if (this.driver)
                this.openRouteController.getDriverSlotsByPhaseId(this.uuid, this.phase.phaseId, busy).subscribe(data => {
                    this.intervals = data;
                    this.loading = false;
                    this.openRouteController.getDriverCanReleaseSlotsByPhaseId(this.uuid, this.phase.phaseId).subscribe(data => {
                        this.canSlotRelease = data;

                        if (!this.canSlotRelease && this.intervals != null && this.intervals.length == 0)
                            this.nooptions = true;
                    });
                });
            else
                this.openRouteController.getExworkSlotsByPhaseId(this.uuid, this.phase.phaseId, busy).subscribe(data => {
                    this.intervals = data;
                    this.loading = false;
                    this.openRouteController.getExworkCanReleaseSlotsByPhaseId(this.uuid, this.phase.phaseId).subscribe(data => {
                        this.canSlotRelease = data;

                        if (!this.canSlotRelease && this.intervals != null && this.intervals.length == 0)
                            this.nooptions = true;
                    });
                });

            if (this.phase != null && this.phase.intervalInfo != null && this.phase.intervalInfo.addressTimetableIntervalId != 0) {
                this.showObservacions = SharedSlotPickerComponent.getShowObservacions(this.phase.intervalInfo);
                if (this.showObservacions) {
                    this.realDate = SharedSlotPickerComponent.getRealDate(this.phase.intervalInfo);
                    this.realInterval = SharedSlotPickerComponent.getRealInterval(this.phase.intervalInfo);
                }
            }
        }
    }
    public getRealIntervalFunc = SharedSlotPickerComponent.getRealInterval;
    public getRealDateFunc = SharedSlotPickerComponent.getRealDate;
    public getShowObservacionsFunc = SharedSlotPickerComponent.getShowObservacions;
    isSelected(addressinterval: AddressTimetableIntervalDto) {
        return addressinterval != null
            && this.slotInfo != null
            && this.slotInfo.addressTimetableIntervalId === addressinterval.addressTimetableIntervalId;
    }
    clickAlliberarSlot() {
        this.intervals = null;

        if (this.driver)
            this.openRouteController.getDriverRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotDriver).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideDriverPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildCancelDriver(this.uuid, this.phase.phaseId)).then(value => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    this.openRouteController.clearDriverPhaseSlot(this.uuid, this.phase.phaseId, new Array()).subscribe(data => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                }
            });
        else
            this.openRouteController.getExworkRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotExwork).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideExworkPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildCancelExwork(this.uuid, this.phase.phaseId)).then(value => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    this.openRouteController.clearExworkPhaseSlot(this.uuid, this.phase.phaseId, new Array()).subscribe(data => {
                        this.slotChanged.next();
                        this.cancel();
                    });
                }
            });

    }
    @Output()
    slotChanged: EventEmitter<void> = new EventEmitter();
    onIntervalSelected(item: AddressTimetableIntervalDto) {
        this.intervals = null;
        if (this.driver)
            this.openRouteController.getDriverRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotDriver).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideDriverPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildSetSlotDriver(this.uuid, this.phase.phaseId, item)).then(value => {
                        this.__autoOpen = false;
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    if (!HLong.isNullOrNullLong(item.addressDaySettingResourceId)) {
                        this.openRouteController.setDriverPhaseSlotByResource(this.uuid, this.phase.phaseId, item.addressDaySettingResourceId, OpenResource.build(item), new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    } else if (!HLong.isNullOrNullLong(item.addressTimetableIntervalId)) {
                        this.openRouteController.setDriverPhaseSlot(this.uuid, this.phase.phaseId, item.addressTimetableIntervalId, new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    }
                }
            });
        else
            this.openRouteController.getExworkRequiredSlotChangeReason(this.uuid, this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlotExwork).subscribe((data: boolean) => {
                if (data) {
                    this.homeController.openAsideExworkPhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildSetSlotExwork(this.uuid, this.phase.phaseId, item)).then(value => {
                        this.__autoOpen = false;
                        this.slotChanged.next();
                        this.cancel();
                    });
                } else {
                    if (!HLong.isNullOrNullLong(item.addressDaySettingResourceId)) {
                        this.openRouteController.setExworkPhaseSlotByResource(this.uuid, this.phase.phaseId, item.addressDaySettingResourceId, OpenResource.build(item), new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    } else if (!HLong.isNullOrNullLong(item.addressTimetableIntervalId)) {
                        this.openRouteController.setExworkPhaseSlot(this.uuid, this.phase.phaseId, item.addressTimetableIntervalId, new Array()).subscribe(data => {
                            this.__autoOpen = false;
                            this.slotChanged.next();
                            this.cancel();
                        });
                    }
                }
            });
    }

    private _intervals: Array<AddressTimetableIntervalDto>
    public set intervals(value: Array<AddressTimetableIntervalDto>) {
        if (this._intervals === value)
            return;
        this._intervals = value;
        this.loadIntervals();
    }
    public get intervals(): Array<AddressTimetableIntervalDto> {
        return this._intervals;
    }

    public addressintervals: AddressTimetableIntervalDto[];
    loadIntervals() {
        this.addressintervals = [];

        if (!this.intervals)
            return;

        if (this.intervals == null || this.intervals.length <= 0)
            return;

        this.intervals.forEach(element => {
            if (!HHourInterval.isNullOrNullValue(element.interval))
                this.addressintervals.push(element);
        });

        if (this.phase == null || this.phase.intervalInfo == null)
            return;
        if (HHourInterval.isNullOrNullValue(this.phase.intervalInfo.interval))
            return;
        /*
        * Afegeix l'interval reservat, indicat per slotInfo, quan no està present al llistat d'intervals
        * d'una fase retornats pel back.
        * */
        let isInTheList = false;
        for (const addressinterval of this.addressintervals) {
            if (addressinterval.addressTimetableIntervalId === this.phase.intervalInfo.addressTimetableIntervalId) {
                isInTheList = true;
                break
            }
        }
        if (!isInTheList) {
            this.addressintervals.push(this.phase.intervalInfo);
        }

    }
    /***
         * True si el n-essim element item te una data diferent a l'anterior
         */
    public trencaData(i: number, item: AddressTimetableIntervalDto): boolean {
        if (i == 0)
            return true;
        let prev = this.addressintervals[i - 1];
        return !HDate.equals(item.onDate, prev.onDate);
    }

    public slotChangedAside(value) {
        this.slotChanged.next();
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
    public cancel(){
        this.show = false;
        this.canSlotRelease = false;
        this.intervals = null;
    }

}
